module.exports = __webpack_public_path__ + "img/dashboard.06836132.svg";